const translations = {
    statesDropdownFieldLabel: 'STATE'
};

export default translations;
